import { render, staticRenderFns } from "./CommunicationTemplateModal.vue?vue&type=template&id=a58da30e&scoped=true&"
import script from "./CommunicationTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./CommunicationTemplateModal.vue?vue&type=script&lang=ts&"
import style0 from "./CommunicationTemplateModal.vue?vue&type=style&index=0&id=a58da30e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58da30e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VSelect,VSwitch,VTextField})
